export const NuxtApollo = {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true, "sameSite": "lax"},
 clients: {"default": {"httpEndpoint": "https://ms.queststore.space/graphql", "httpLinkOptions": {"fetchOptions": {"credentials": "include"}}, "tokenStorage": "cookie", "authType": "Bearer", "authHeader": "Authorization", "tokenName": "access_token", "defaultOptions": {"watchQuery": {"errorPolicy": "all"}, "query": {"errorPolicy": "all"}}}}
}